'use client';
import type { UserOverview } from '~/common/types/user-overview';
import { Stats } from '@app/(default-layout)/user/[userId]/_containers/user-header-container/stats';
import { css } from '@styled-system/css';
import { Box } from '@styled-system/jsx';
import { FollowListModal } from './follow-list-modal';
import { useLocalHooks } from './use-local-hooks';

type Props = {
  user: UserOverview;
  followerCount: number;
  followeeCount: number;
};

export const FollowsContainer = ({
  followerCount,
  followeeCount,
  user,
}: Props) => {
  const {
    followList,
    followListType,
    followListingsModalDisclosure,
    handleFollowButtonClick,
    closeListingsModal,
    paginationRef,
    isLoading,
    isLoadingFirstPage,
    changeList,
    error,
    isEmpty,
  } = useLocalHooks(user.id);
  return (
    <>
      <Box
        className={followButtonStyle}
        onClick={() => handleFollowButtonClick('follower')}
      >
        <Stats count={followerCount ?? 0} label="フォロワー" />
      </Box>
      <Box
        className={followButtonStyle}
        onClick={() => handleFollowButtonClick('followee')}
      >
        <Stats count={followeeCount ?? 0} label="フォロー中" />
      </Box>
      <FollowListModal
        isOpen={followListingsModalDisclosure.isOpen}
        listType={followListType}
        onClose={closeListingsModal}
        paginationRef={paginationRef}
        isLoading={isLoading}
        isLoadingFirstPage={isLoadingFirstPage}
        userList={followList || []}
        onChangeList={changeList}
        error={error}
        isEmpty={isEmpty}
        user={user}
      />
    </>
  );
};

const followButtonStyle = css({
  _hover: {
    cursor: 'pointer',
    backgroundColor: 'token(colors.accent.50)',
  },
});
